import React from 'react';

import { imageHooks } from '../../hooks/imageHooks/imageHooks';
import { versionDependent } from '../../images/versionDependentExport';
import styles from './HeaderDecoration.module.css';

export const HeaderDecoration = React.memo(() => {
  const decorationSrc = imageHooks.useImageSrc(versionDependent.headerDecoration?.src);

  return (
    <div className={styles.headerDecoration} style={{
      backgroundImage: `url("${decorationSrc}")`,
    }} />
  );
});

HeaderDecoration.displayName = 'HeaderDecoration';
